interface BrandProps {
  withPulse?: boolean;
  href?: string;
}

export function Brand({ withPulse = false, href = '/' }: BrandProps) {
  return (
    <a href={href} className="brand">
      <span className="name">furtif</span>
      <span className="tld">.fm</span>
      {withPulse && <span className="brand-cursor" aria-hidden="true">_</span>}
    </a>
  );
}
